import type {
  Catalog,
  CollaboratorItem,
  MessageItem,
  RequestDetailsModel,
  RequestLinkableBookingItem,
  RequestsListItem,
  RequestsListPagination,
  SelectedRequestUser,
} from "@simbelapp/order-sdk";
import type { IErrorObject, ITrainingPartner } from "~/utils/interfaces/trainings-interface";
import type { ICompanyUsersSDK } from "./users-interfaces";
import { SessionItemFormatEnum, SessionItemModalityEnum } from "~/utils/enums/session-items.enums";
import type { IAIAgentMessage } from "~/utils/interfaces/ai-agent-interfaces";

export interface IRequestStore {
  requests: RequestsListPagination | null;
  collaborators: CollaboratorItem[];
  requestDetails: RequestDetailsModel | null;
  messages: MessageItem[];
  showDuplicatedModal: boolean;
  showRefuseModal: boolean;
  showCsvImportModal: boolean;
  showCancelModal: boolean;
  showRemoveModal: boolean;
  showPauseModal: boolean;
  showEditCostModal: boolean;
  selectedRequestsList: RequestsListItem[];
  excludedRequestsList: (RequestsListItem | SelectedRequestUser)[];
  duplicatedRequests: SelectedRequestUser[];
  showAIAgentModal: boolean;
  AIAgentMessages: IAIAgentMessage[];
  AIAgentContextId: string | null;
  AIAgentUserQuery: string | null;
  bookingRecommendation: RequestLinkableBookingItem | null;
  showBookingRecommendationsModal: boolean;
  bookingRecommendations: RequestLinkableBookingItem[];
  requestsToProcess: SelectedRequestUser[];
}

export enum RequestStep {
  ChoiceSession,
  AddComment,
}
export interface ICreateRequest {
  request: {
    trainingId: string | null;
    sessionId: Record<string, any> | null;
    usersToInvite: ICompanyUsersSDK[];
    employeeComment: string | null;
    managerComment: string | null;
    managerPriority: Record<string, any> | null;
    isUnqualified: boolean;
  };
  nav: any; // TODO:
  isCheckedForMe: boolean;
  isCheckedForOther: boolean;
  showExit: boolean;
  showModal: boolean;
  showConfirm: boolean;
  usersError: string | null;
  employeeCommentError: string | null;
  managerPriorityError: string | null;
  radioError: string | null;
  stepModal: RequestStep | null;
  noSessionSelected: boolean;
  isDesktop: boolean;
  choiceSessionError: boolean;
  usersAlreadyRegisteredModal: boolean;
  usersAlreadyRegisteredData: Array<{
    bookingId: string;
    displayValue: string;
    userId: string;
    startDate: string;
    endDate: string;
  }>;
}

export interface IOffCatalogRequestStore {
  training: {
    trainingPartner: ITrainingPartner | null;
    training: Catalog | null;
    externalUrl: string | null;
    durationHours: number | null;
    format: SessionItemFormatEnum | null;
    price: number | null;
    inclTax: boolean | null;
    modality: SessionItemModalityEnum | null;
    startDate: Date | null;
    endDate: Date | null;
    employeeComment: string | null;
  };
  errors: IErrorObject;
  showModal: boolean;
  step: number;
  isDesktop: boolean;
}

export interface IOffCatalogRequestStoreStandalone {
  training: Catalog | null;
  errors: IErrorObject;
  showModal: boolean;
  step: number;
  isDesktop: boolean;
  sessions: any[];
  noSessionSelected: boolean;
  hasIdentifiedTraining: boolean | null;
  userSpecifyContext: {
    employeeComment: string | null;
  };
  managerSpecifyContext: {
    managerComment: string | null;
    managerPriority: { key: string; value: string } | null;
    managerPriorityComment: string | null;
    usersToInvite: ICompanyUsersSDK[];
  };
  showConfirm: boolean;
  isCatalogRequest: boolean;
  showExitModal: boolean;
}

export interface IGetSelectedRequests {
  selectedRequests: SelectedRequestUser[];
  requestsOfUsersWithMultipleRequests: SelectedRequestUser[];
}

export interface IRequestTotalCount {
  toProcess?: number;
  processed?: number;
}
